var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItsWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "93.000000pt",
    height: "101.000000pt",
    viewBox: "0 0 93.000000 101.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,101.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259 851 l-204 -117 -3 -50 c-3 -46 -1 -51 23 -62 25 -11 25 -11 25 32 l0 44 181 105 181 104 79 -44 c43 -25 79 -48 79 -52 0 -3 -79 -51 -175 -106 l-175 -100 0 -46 c0 -39 4 -50 24 -63 l25 -16 3 47 3 47 202 116 c111 63 202 117 203 120 0 3 -39 28 -87 55 -48 28 -108 62 -134 77 l-46 27 -204 -118z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 753 l-148 -86 0 -45 c0 -31 5 -49 18 -58 27 -21 32 -17 32 25 0 21 6 44 14 50 8 7 76 47 151 90 134 78 136 79 113 95 -12 9 -25 16 -28 16 -3 -1 -71 -40 -152 -87z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665 704 c-72 -40 -131 -77 -132 -81 -2 -5 6 -14 18 -21 17 -11 27 -9 75 19 30 17 61 28 69 25 13 -4 15 -44 15 -246 l0 -240 25 16 25 16 0 237 c0 158 -4 241 -11 248 -8 8 3 18 40 38 51 28 55 37 23 54 -13 7 -48 -8 -147 -65z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838 679 c-16 -9 -18 -31 -18 -229 0 -121 3 -220 6 -220 3 0 14 5 25 10 18 10 19 23 19 230 0 121 -3 220 -7 220 -5 0 -16 -5 -25 -11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 477 l0 -95 205 -117 c122 -70 211 -115 220 -112 12 5 15 -1 15 -27 0 -21 -6 -36 -15 -40 -8 -3 -95 41 -205 105 -104 60 -196 112 -205 115 -11 5 -15 -1 -15 -22 0 -27 14 -37 205 -147 l205 -117 40 20 40 20 0 96 0 95 -39 -22 -39 -22 -154 88 c-199 115 -208 121 -208 151 0 13 5 24 10 24 6 0 87 -44 181 -99 l171 -98 39 21 c33 18 39 26 39 53 l0 33 -32 -20 c-18 -11 -38 -20 -45 -20 -6 0 -94 47 -194 105 -100 59 -190 110 -201 116 -17 9 -18 4 -18 -84z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623 553 c-23 -15 -23 -19 -23 -234 l0 -219 25 12 25 11 0 224 c0 122 -1 223 -2 222 -2 0 -13 -7 -25 -16z",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItsWhite);
export default __webpack_public_path__ + "static/media/its-white.0a94feb9.svg";
export { ForwardRef as ReactComponent };